( function () {
   
    'use strict';

    ( function ( $ ) {
        
        $(".all-news-list").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".all-news-list").removeClass('active');
              $(this).addClass('active');
              $(".all-news-list-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $('.news-slider').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '120px',
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:false,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        centerPadding: '60',
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        centerPadding: '40px',
                        slidesToShow: 1,
                    }
                }
            ]
        });
        $('.video-slider').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '120px',
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:false,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        centerPadding: '60',
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        centerPadding: '40px',
                        slidesToShow: 1,
                    }
                }
            ]
        });
        $('.image-slider').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '120px',
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:false,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        centerPadding: '60',
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        centerPadding: '40px',
                        slidesToShow: 1,
                    }
                }
            ]
        });
    } )(jQuery);
} )();

